/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type MentorShiftsQueryVariables = Types.Exact<{
  where: Types.EventActivityWhereInput;
}>;

export type MentorShiftsQuery = {
  mentorShifts: Array<
    Pick<
      Types.EventActivity,
      | "category"
      | "created_at"
      | "end_time"
      | "event_id"
      | "id"
      | "location"
      | "name"
      | "restrictions"
      | "start_time"
      | "updated_at"
      | "slug"
      | "restrictions_string"
    > & {
      shift_signups?: Types.Maybe<Array<Pick<Types.ShiftSignup, "shift_id">>>;
    }
  >;
};

export const MentorShiftsDocument = gql`
  query MentorShifts($where: EventActivityWhereInput!) {
    mentorShifts(where: $where) {
      category
      created_at
      end_time
      event_id
      id
      location
      name
      restrictions
      start_time
      updated_at
      slug
      restrictions_string
      shift_signups {
        shift_id
      }
    }
  }
`;

/**
 * __useMentorShiftsQuery__
 *
 * To run a query within a React component, call `useMentorShiftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMentorShiftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMentorShiftsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMentorShiftsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    MentorShiftsQuery,
    MentorShiftsQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    MentorShiftsQuery,
    MentorShiftsQueryVariables
  >(MentorShiftsDocument, baseOptions);
}
export function useMentorShiftsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MentorShiftsQuery,
    MentorShiftsQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    MentorShiftsQuery,
    MentorShiftsQueryVariables
  >(MentorShiftsDocument, baseOptions);
}
export type MentorShiftsQueryHookResult = ReturnType<
  typeof useMentorShiftsQuery
>;
export type MentorShiftsLazyQueryHookResult = ReturnType<
  typeof useMentorShiftsLazyQuery
>;
export type MentorShiftsQueryResult = ApolloReactCommon.QueryResult<
  MentorShiftsQuery,
  MentorShiftsQueryVariables
>;
